export default {
      id: "comment-usage",
      viewBox: "0 0 17 15",
      url: __webpack_public_path__ + "icons-sprite.c706496.svg#comment-usage",
      toString: function () {
        return this.url;
      }
    }